import React from 'react';
import {useTranslation} from 'react-i18next';
import {ReactComponent as Down} from '../../assets/icon/down.svg';

const MoreBtn = ({
  onClick,
  expend = false,
}: {
  onClick?: () => void;
  expend?: boolean;
}) => {
  const {t} = useTranslation();
  return (
    <div
      onClick={onClick}
      className="border border-[#9FA6AC] flex flex-row items-center bg-white rounded-lg h-[1.75rem] w-[4.125rem] justify-center">
      <p className="font-bold text-sm mr-1">{t('home.label.more')}</p>
      <div className={`${expend ? '-rotate-180' : 'rotate-0'} transition-all`}>
        <Down />
      </div>
    </div>
  );
};

export default MoreBtn;
